import { render } from "./AppFooter.vue?vue&type=template&id=4eb0c0ba&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=4eb0c0ba&lang=scss"
import "./AppFooter.vue?vue&type=style&index=1&id=4eb0c0ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb0c0ba"]])

export default __exports__